export default "__VITE_ASSET__ac673357__"